module.exports = "/_next/static/images/OgImageCDPWeek2024-59a1ee8f55eb60648c7726aae30422b3.png";